import { Event_ } from '../Event_';
export class FocusEvent_ extends Event_ {
    get relatedTarget() {
        return this.reactEvent.relatedTarget;
    }
}
